"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoLimitGambleFiftyFiftyGambleView = void 0;
const ImgLoader_1 = require("@nolimitcity/slot-launcher/bin/loader/ImgLoader");
const GambleAssetConfig_1 = require("../config/GambleAssetConfig");
const IconToggleButton_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/IconToggleButton");
const PointerStateColorSet_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/states/sets/PointerStateColorSet");
const PointerStateIconSet_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/states/sets/PointerStateIconSet");
const Icon_1 = require("@nolimitcity/slot-launcher/bin/gui/displayobjects/Icon");
const TimelineSprite_1 = require("@nolimitcity/slot-launcher/bin/animation/TimelineSprite");
const gsap_1 = require("gsap");
const FontStatics_1 = require("@nolimitcity/slot-launcher/bin/loader/font/FontStatics");
const NoLimitGamblePlugin_1 = require("../NoLimitGamblePlugin");
const NolimitApplication_1 = require("@nolimitcity/slot-launcher/bin/NolimitApplication");
const GambleEvents_1 = require("../config/GambleEvents");
const GambleGameMode_1 = require("../config/GambleGameMode");
class NoLimitGambleFiftyFiftyGambleView extends PIXI.Container {
    /**
     * @constructs
     * @param redClickCb
     * @param blackClickCb
     */
    constructor(redClickCb, blackClickCb) {
        super();
        this._allCardFlipTextures = [];
        this._centerX = 360;
        this._centerY = 360;
        this._previousCards = [-1, -1, -1, -1, -1, -1, -1, -1];
        this._previousCardsItems = [];
        this._previousCardsTextures = [];
        this._redClickCallback = redClickCb;
        this._blackClickCallback = blackClickCb;
        this.init();
    }
    /**
     * @description When red button is clicked.
     */
    onRedButtonClick() {
        this.disableButtons();
        this.playBtnAnimation(this._redButton);
    }
    /**
     * @description When black button is clicked.
     */
    onBlackButtonClick() {
        this.disableButtons();
        this.playBtnAnimation(this._blackButton);
    }
    /**
     * @description To show the view.
     */
    show() {
        this.visible = true;
        this.enableButtons();
        this._cardsBg.visible = true;
        this.updatePreviousCards();
    }
    /**
     * @description When gamble module is all done.
     */
    allDone() {
        this.hide();
        this.resetCard();
    }
    /**
     * @description To play the card flip animation when server response is received.
     * @param val
     * @param isSuccess
     * @param nextMode
     * @param winAmount
     */
    playCardFlipAnimation(val, isSuccess, nextMode, winAmount) {
        const tl = new gsap_1.TimelineLite();
        this._nextMode = nextMode;
        this._cardFlipAnimation._textures = this._allCardFlipTextures[val];
        //Setup card
        tl.add(() => {
            this._cardsBg.visible = false;
            this._cardFlipAnimation.show();
        });
        //Flip card
        tl.add(this._cardFlipAnimation.getAnimation());
        //Card cleanup
        tl.add(() => {
            this._previousCards.pop();
            this._previousCards.unshift(val);
            this.updatePreviousCards();
        });
        //Win presentation
        if (isSuccess) {
            tl.add(this.getWinAnimation(winAmount));
        }
        else {
            tl.add(this.getLoseAnimation());
        }
        return tl;
    }
    /**
     * @description To disable all buttons.
     */
    disableButtons() {
        this.killTimeline();
        this._redButton.enable(false);
        this._blackButton.enable(false);
    }
    /**
     * @description To reset the card back to its initial state.
     */
    resetCard() {
        this._cardFlipAnimation.hide();
        this._cardFlipAnimation._textures = PIXI.Texture.EMPTY;
        this._cardsBg.visible = true;
    }
    /**
     * @description To get the win text animation.
     * @param winAmount
     */
    getWinAnimation(winAmount) {
        const tl = new gsap_1.TimelineLite();
        tl.add([
            this.getTextAnimation(NoLimitGamblePlugin_1.NoLimitGamblePlugin.apiPlugIn.translations.translate(NoLimitGamblePlugin_1.NoLimitGamblePlugin.WIN_TEXT).toUpperCase()),
            () => {
                const soundConfig = {
                    name: NoLimitGamblePlugin_1.NoLimitGamblePlugin.WIN_CARD_SOUND,
                    loop: false
                };
                NolimitApplication_1.NolimitApplication.events.trigger(GambleEvents_1.GambleEvents.GAMBLE_PLAY_EFFECT_SOUND, soundConfig);
            },
            () => NoLimitGamblePlugin_1.NoLimitGamblePlugin.keypadPlugin.setWin(winAmount)
        ]);
        tl.add(() => this.onSuccess());
        return tl;
    }
    /**
     * @description To get the lose text animation.
     */
    getLoseAnimation() {
        const tl = new gsap_1.TimelineLite();
        tl.add([
            this.getTextAnimation(NoLimitGamblePlugin_1.NoLimitGamblePlugin.apiPlugIn.translations.translate(NoLimitGamblePlugin_1.NoLimitGamblePlugin.LOSE_TEXT).toUpperCase()),
            () => {
                const soundConfig = {
                    name: NoLimitGamblePlugin_1.NoLimitGamblePlugin.LOSE_CARD_SOUND,
                    loop: false
                };
                NolimitApplication_1.NolimitApplication.events.trigger(GambleEvents_1.GambleEvents.GAMBLE_PLAY_EFFECT_SOUND, soundConfig);
            }
        ]);
        return tl;
    }
    /**
     * @description To get the text animation.
     * @param text
     */
    getTextAnimation(text) {
        const tl = new gsap_1.TimelineLite();
        tl.add(() => {
            this._winText.text = text;
            this._winText.scale.set(0, 0);
            this.addChild(this._winText);
        });
        tl.add(new gsap_1.TweenLite(this._winText.scale, 0.1, { x: 1, y: 1 }));
        tl.add(new gsap_1.TweenLite(this._winText.scale, 0.1, { x: 0, y: 0 }), "+=1");
        tl.add(() => {
            this.removeChild(this._winText);
        });
        return tl;
    }
    /**
     * @description To hide the view.
     */
    hide() {
        this.visible = false;
        this.disableButtons();
    }
    /**
     * @description To init the view.
     */
    init() {
        this.createFiftyFiftyTextImage();
        this.createHeaderText();
        this.createButtons();
        this.createRedBlackToggle();
        this.createCards();
        this.createBtnClickAnimation();
        this.createPreviousCardsSection();
        this.createWinText();
        this.visible = false;
    }
    /**
     * @description To create the win text.
     */
    createWinText() {
        this._winText = new PIXI.Text("WIN", NoLimitGamblePlugin_1.NoLimitGamblePlugin.winLoseTextStyle);
        this._winText.anchor.set(0.5, 0.5);
        this._winText.position.set(360, 230);
    }
    /**
     * @description To create the 50/50 text image.
     */
    createFiftyFiftyTextImage() {
        const yPos = 140;
        let item = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig.FIFTY_FIFTY_TEXT));
        item.anchor.set(0.5);
        item.position.set(this._centerX, yPos);
        this.addChild(item);
    }
    /**
     * @description To create the header text.
     */
    createHeaderText() {
        const textStyle = new PIXI.TextStyle({
            fill: "#CACACA",
            fontFamily: "Open Sans",
            fontSize: 20,
            fontStyle: FontStatics_1.FontStyle.NORMAL
        }), yPos = 210, item = new PIXI.Text(NoLimitGamblePlugin_1.NoLimitGamblePlugin.apiPlugIn.translations.translate(NoLimitGambleFiftyFiftyGambleView.HEADER_TEXT), textStyle);
        item.anchor.set(0.5);
        item.position.set(this._centerX, yPos);
        this.addChild(item);
    }
    /**
     * @description To create the buttons.
     */
    createButtons() {
        const colors = new PointerStateColorSet_1.PointerStateColorSet(0xffffffff), onIconsRed = new PointerStateIconSet_1.PointerStateIconSet(new Icon_1.Icon(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig.RED_BUTTON))), onIconsBlack = new PointerStateIconSet_1.PointerStateIconSet(new Icon_1.Icon(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig.BLACK_BUTTON))), redBtn = new IconToggleButton_1.IconToggleButton(NoLimitGambleFiftyFiftyGambleView.RED_BUTTON, onIconsRed, colors), blackBtn = new IconToggleButton_1.IconToggleButton(NoLimitGambleFiftyFiftyGambleView.BLACK_BUTTON, onIconsBlack, colors), btnOffsetX = 200;
        redBtn.addClickCallback(() => this._redClickCallback());
        redBtn.toggled = false;
        redBtn.pivot.set(redBtn.width / 2, redBtn.height / 2);
        redBtn.position.set(this._centerX - btnOffsetX, this._centerY);
        this._redButton = redBtn;
        blackBtn.addClickCallback(() => this._blackClickCallback());
        blackBtn.toggled = false;
        blackBtn.pivot.set(blackBtn.width / 2, blackBtn.height / 2);
        blackBtn.position.set(this._centerX + btnOffsetX, this._centerY);
        this._blackButton = blackBtn;
        this.addChild(this._redButton, this._blackButton);
    }
    /**
     * @description To create the blinking toggle timeline for the red and black buttons.
     */
    createRedBlackToggle() {
        const redToggle = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig.RED_BUTTON_TOGGLE)), blackToggle = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig.BLACK_BUTTON_TOGGLE)), toggleTl = new gsap_1.TimelineLite({
            paused: true,
            onComplete: () => { this._toggleTl.restart(); }
        }), duration = 0.4;
        redToggle.visible = false;
        redToggle.anchor.set(0.5);
        redToggle.position.set(this._redButton.x, this._redButton.y);
        blackToggle.visible = false;
        blackToggle.anchor.set(0.5);
        blackToggle.position.set(this._blackButton.x, this._blackButton.y);
        toggleTl.add(() => { redToggle.visible = true; });
        toggleTl.add(() => {
            redToggle.visible = false;
            blackToggle.visible = true;
        }, duration);
        toggleTl.add(() => { blackToggle.visible = false; }, (2 * duration));
        this._toggleTl = toggleTl;
        this._redToggle = redToggle;
        this._blackToggle = blackToggle;
        this.addChild(redToggle, blackToggle);
    }
    /**
     * @description To create the cards related stuff.
     */
    createCards() {
        const cardGlow = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig.CARD_GLOW)), cardsBg = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig.CARDS_BG)), cardFlipAnimation = new TimelineSprite_1.TimelineSprite([ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig.CARDS_BG)], 15);
        cardGlow.anchor.set(0.5);
        cardGlow.blendMode = PIXI.BLEND_MODES.ADD;
        cardGlow.position.set(this._centerX, this._centerY);
        cardsBg.anchor.set(0.5);
        cardsBg.position.set(this._centerX, this._centerY);
        cardFlipAnimation.hide();
        cardFlipAnimation.anchor.set(0.5);
        cardFlipAnimation.position.set(this._centerX, this._centerY);
        this._cardsBg = cardsBg;
        this._cardFlipAnimation = cardFlipAnimation;
        this.addChild(cardGlow, cardsBg, cardFlipAnimation);
        this.createAllCardFlipTextures();
    }
    /**
     * @description To store all the card flip textures.
     */
    createAllCardFlipTextures() {
        const allTextures = [], type = ["RED_HEART_", "BLACK_SPADE_"], len = 4;
        let name;
        for (let i = 0; i < type.length; i++) {
            allTextures.push([]);
            allTextures[i].push(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig.CARDS_COMMON_ANIM));
            for (let k = 0; k < len; k++) {
                name = type[i] + k;
                allTextures[i].push(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig[name]));
            }
        }
        this._allCardFlipTextures = allTextures;
    }
    /**
     * @description To create button click's shine animation.
     */
    createBtnClickAnimation() {
        const len = 9;
        let textures = [], name, animationItem;
        for (let i = 0; i < len; i++) {
            name = "CLICK_ANIMATION_" + i;
            textures.push(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig[`${name}`]));
        }
        animationItem = new TimelineSprite_1.TimelineSprite(textures);
        animationItem.visible = false;
        animationItem.anchor.set(0.5);
        animationItem.blendMode = PIXI.BLEND_MODES.ADD;
        this.addChild(animationItem);
        this._btnClickAnimation = animationItem;
    }
    /**
     * @description To create the previous cards section.
     */
    createPreviousCardsSection() {
        const baseX = 190, baseY = 528, itemWidth = 45, type = ["RED_HEART_HISTORY", "BLACK_SPADE_HISTORY"], textStyle = new PIXI.TextStyle({
            fill: "#CACACA",
            fontFamily: "Open Sans",
            fontSize: 22,
            fontStyle: FontStatics_1.FontStyle.NORMAL,
            fontWeight: FontStatics_1.FontWeight.BOLD
        }), textString = NoLimitGamblePlugin_1.NoLimitGamblePlugin.apiPlugIn.translations.translate(NoLimitGambleFiftyFiftyGambleView.PREVIOUS_CARDS_TEXT), text = new PIXI.Text(textString, textStyle), offsetXText = 10, offsetYText = 8, maxTextWidth = 165; // in english the width is 161.
        let item;
        NoLimitGamblePlugin_1.NoLimitGamblePlugin.shrinkTextViaFont(textString, text, maxTextWidth);
        text.position.set(offsetXText, baseY + offsetYText);
        this.addChild(text);
        for (let i = 0; i < this._previousCards.length; i++) {
            item = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig.RED_HEART_HISTORY));
            item.visible = false;
            if (i === 0) {
                item.position.set(baseX, baseY);
            }
            else {
                item.position.set(this._previousCardsItems[i - 1].x + (1.5 * itemWidth), baseY);
            }
            this.addChild(item);
            this._previousCardsItems.push(item);
        }
        for (let i = 0; i < type.length; i++) {
            this._previousCardsTextures.push(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig[type[i]]));
        }
    }
    /**
     * @description To enable all buttons.
     */
    enableButtons() {
        this._redButton.enable(true);
        this._blackButton.enable(true);
        this._toggleTl.restart();
    }
    /**
     * @description To play the button animation when any button is pressed.
     * @param btn
     */
    playBtnAnimation(btn) {
        gsap_1.TweenLite.to(btn.scale, 2 / 30, {
            x: 0.9,
            y: 0.9,
            onComplete: () => {
                gsap_1.TweenLite.to(btn.scale, 4 / 30, {
                    x: 1,
                    y: 1
                });
            }
        });
        this._btnClickAnimation.position.set(btn.x, btn.y);
        this._btnClickAnimation.getAnimationAutoShowHide(true, true);
    }
    /**
     * @description When gamble is successful at the moment.
     */
    onSuccess() {
        if (this._nextMode !== GambleGameMode_1.GambleGameMode.GAMBLE) {
            return;
        }
        this.enableButtons();
        this.resetCard();
    }
    /**
     * @description To update the previous cards textures.
     */
    updatePreviousCards() {
        let item;
        for (let i = 0; i < this._previousCardsItems.length; i++) {
            item = this._previousCardsItems[i];
            if (this._previousCards[i] !== -1) {
                item.texture = this._previousCardsTextures[this._previousCards[i]];
                item.visible = true;
            }
        }
    }
    /**
     * @description To kill the toggle timeline.
     */
    killTimeline() {
        this._toggleTl.pause();
        this._toggleTl.kill();
        this._redToggle.visible = false;
        this._blackToggle.visible = false;
    }
}
exports.NoLimitGambleFiftyFiftyGambleView = NoLimitGambleFiftyFiftyGambleView;
NoLimitGambleFiftyFiftyGambleView.RED_BUTTON = "redButton";
NoLimitGambleFiftyFiftyGambleView.BLACK_BUTTON = "blackButton";
NoLimitGambleFiftyFiftyGambleView.HEADER_TEXT = "Guess the color of the next card to double your winnings.";
NoLimitGambleFiftyFiftyGambleView.PREVIOUS_CARDS_TEXT = "Previous cards";
//# sourceMappingURL=NoLimitGambleFiftyFiftyGambleView.js.map